/**
 * Doing this inline makes eslint complain
 * @typedef {import('vuex').Store} VuexStore
 */

/**
 * Base class for panel lights integration
 */
export class PanelLights {
  /**
   * @param {VuexStore} store
   */
  constructor(store) {
    this.store = store;
  }

  /**
   * Set LEDs on room state change
   * @param {RoomState} state
   */
  async onRoomStateChange(state) {}
  /**
   * check the LED status is correct
   */
  runLedCheck() {}

  /**
   * @return {RoomState}
   * @private
   */
  get _roomState() {
    return this.store.getters['room/roomState'];
  }

  /**
   * [0,1]
   * @return {number}
   * @private
   */
  get _brightness() {
    return this.store.getters['config/panelLightsBrightness'];
  }
}
